class Tabs {
    constructor(tabs) {
        this.tabs = tabs;
        this.id = this.tabs.getAttribute('data-container');
        this.links = this.tabs.querySelectorAll('[data-tab]');
        this.containers = document.querySelectorAll(`#${this.id} [data-tab]`);

        this.bindClick();
    }

    bindClick() {
        this.links.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                this.filter(+btn.getAttribute('data-tab'));
            });
        });
    }

    filter(id) {
        this.containers.forEach(ct => {
            if (id === +ct.getAttribute('data-tab')) {
                ct.classList.add('_is-active');
            } else {
                ct.classList.remove('_is-active');
            }
        });

        this.links.forEach(ct => {
            if (id === +ct.getAttribute('data-tab')) {
                ct.classList.add('_is-active');
            } else {
                ct.classList.remove('_is-active');
            }
        });
    }
}

document.querySelectorAll('.js-tabs').forEach(tab => {
    new Tabs(tab);
});



// WEBPACK FOOTER //
// ./_src/js/Tabs.js